module.exports = __webpack_public_path__ + "e21eb8b03f4781d1e9b916f497cbab64.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-3.png
// module id = 3014
// module chunks = 0